import React from 'react'
import { hydrateRoot } from 'react-dom/client'

import SummarySSR from './views/SummarySSR'
import { SummaryProvider } from '../configs/summary-view/state.manager'
import { I18nextProvider, i18nConfig } from '../internationalization/src'

import '@sm360/summary-360/dist/views/summary/summary.view.css'

const preloadedState = window.__PRELOADED_STATE__
delete window.__PRELOADED_STATE__

const { initialData } = preloadedState

hydrateRoot(
    document.getElementById('widget-summary-360'),
    <I18nextProvider i18n={i18nConfig}>
        <SummaryProvider initialData={initialData}>
            <SummarySSR />
        </SummaryProvider>
    </I18nextProvider>
)

if (module.hot) {
    module.hot.accept()
}
